import { ref, Ref } from "vue";
import { ZombicideEdition, ZombieType, SpawnCardType } from "@/shared/types";
const defaultDeck = require("@/assets/json/ZombicideBlackPlagueDefaultDeck.json");

export interface SpawnData{
    type: ZombieType,
    count: Number
}
export interface SpawnCardInterface{
    edition: ZombicideEdition,
    cardType: SpawnCardType
    spawnData: {
        blue: SpawnData,
        yellow: SpawnData,
        orange: SpawnData,
        red: SpawnData,
    }
}

export const spawnDeck: Ref<SpawnCardInterface[]> = ref([...defaultDeck]);

export const addToDeck = (data: SpawnCardInterface) => {
    spawnDeck.value.push({
        edition: data.edition,
        cardType: data.cardType,
        spawnData: data.spawnData
    });
}
export const deleteCardFromDeckByIndex = (index: number) => {
    spawnDeck.value.splice(index, 1);   
}
export const saveDeck = () => {
    const jsonString = JSON.stringify(spawnDeck.value);
    const blob = new Blob([jsonString], { type: 'text/plain' });
    const a = document.createElement('a');
    a.setAttribute('download', "ZombicideSpawnDeck.json");
    a.setAttribute('href', window.URL.createObjectURL(blob));
    a.click();
}

export const loadDeck = () => {
    const input = document.createElement('input');
    input.type = "file";
    input.accept = ".json";
    input.onchange = (e: any) => {
        const reader = new FileReader();
        reader.onload = (e: any) => {
            const parsedJSON = JSON.parse(e.target.result);
            spawnDeck.value = parsedJSON;
        };
        reader.readAsText(e.target.files[0]);
    }
    input.click();
}

/**
 * Debug
 
spawnDeck.value = spawnDeck.value.sort((a: any,b: any): any => {
    console.log(a.cardType)
    return b.cardType.localeCompare(a.cardType);
})
*/